import { ACTION_CANCEL_ASSIGNMENT } from '../../store/state/actions';
import { executeReleaseLockRequest } from '../release-lock/async-request';

import type { CancelActionInPayload } from './types';

export const executeCancelAssignmentRequest = (
  actionInPayload: CancelActionInPayload,
  options: { isModalAction: boolean }
) => {
  const { isModalAction } = options;
  /* release lock on assignment */
  return executeReleaseLockRequest({
    routeKey: ACTION_CANCEL_ASSIGNMENT,
    isModalAction,
    ...actionInPayload
  });
};

export default executeCancelAssignmentRequest;
